var _path, _path2, _g, _g2, _path3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoteResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 10             L85 30             L85 70             L50 90",
    fill: "none",
    stroke: "#45A05A",
    strokeWidth: 6,
    strokeDasharray: "2,2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 90            L15 70            L15 30             L50 10",
    fill: "none",
    stroke: "#45A05A",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 55) scale(0.55, 0.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30 5              C-40 5, -40 -5, -35 -10              C-35 -20, -20 -25, -10 -20              C-10 -30, 10 -30, 10 -20              C20 -25, 35 -20, 35 -10              C40 -5, 40 5, 30 5              C25 15, 10 15, 0 10              C-10 15, -25 15, -30 5Z",
    fill: "white",
    stroke: "#90A4AE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 -20              C-10 -30, 10 -30, 10 -20              C0 -25, -10 -25, -10 -20Z",
    fill: "#E3F2FD",
    opacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 52 A 35 35 0 0 1 80 52",
    fill: "none",
    stroke: "#43A047",
    strokeWidth: 3,
    strokeDasharray: "0,8,3,8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;19",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.66s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 58 A 35 35 0 0 1 80 58",
    fill: "none",
    stroke: "#66BB6A",
    strokeWidth: 3,
    strokeDasharray: "0,8,3,8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;19",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.33s"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50            l20 -8            l-20 8            l20 8            l-20 -8            Z",
    fill: "#546E7A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#CFFFD8",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 10,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 30,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 70,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 90,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 70,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 30,
    r: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteResource);
export default __webpack_public_path__ + "static/media/remote_resource.2ea495f4b34bd705d048fe6ffc2aada2.svg";
export { ForwardRef as ReactComponent };